import React from "react";
import Skeleton from "react-loading-skeleton";
import "./style.css";

const TeamCardLoader = ({ item, getTeamEvents }) => {
  return (
    <div className={`cards_of_team_comp`}>
      <Skeleton
        count={1}
        style={{
          "--base-color": "#ccc",
          "--highlight-color": "#f5f5f5",
        }}
        inline
      />
      <div className="card_chip">
        <Skeleton
          count={1}
          width={200}
          height={40}
          style={{
            "--base-color": "#ccc",
            "--highlight-color": "#f5f5f5",
          }}
          inline
        />
      </div>
    </div>
  );
};

export default TeamCardLoader;
